import { render } from "./MatchingModal.vue?vue&type=template&id=1d887dfc&scoped=true&ts=true&lang=pug"
import script from "./MatchingModal.vue?vue&type=script&lang=ts"
export * from "./MatchingModal.vue?vue&type=script&lang=ts"

import "./MatchingModal.vue?vue&type=style&index=0&id=1d887dfc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d887dfc"]])

export default __exports__